module.exports = __webpack_public_path__ + "328cf7d6e08eec21013a94751c8de49e.mp3";